import { AppModal } from 'shared/UI/UIKit/Modal';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppDeleteIcon } from 'shared/UI/UIKit/icons/Delete';
import { AppText } from 'shared/UI/UIKit/Text';
import { educationParallelTextRepresentation } from 'entities/education-class';
import type { EducationClass } from 'shared/api';
import { useDeleteEducationClass } from '../model';
import styles from './styles.module.scss';

interface DeleteEducationClassProps {
  selectedEducationClass: EducationClass;
}

export const DeleteEducationClass = ({ selectedEducationClass }: DeleteEducationClassProps) => {
  const {
    state: { isLoading, visible },
    methods: { showModal, onSubmit, hideModal },
  } = useDeleteEducationClass(selectedEducationClass);

  const footer = (
    <AppFlex direction="row">
      <AppButton onClick={onSubmit}>Удалить</AppButton>
      <AppButton type="outline" onClick={hideModal}>
        Отмена
      </AppButton>
    </AppFlex>
  );

  const content = (
    <AppFlex unit="8" className={styles.content}>
      <AppText size={16} type="secondary">
        Подтвердите удаление класса
      </AppText>
      <AppText size={18}>{`${educationParallelTextRepresentation[selectedEducationClass.parallel]}${
        selectedEducationClass.litera
      }`}</AppText>
    </AppFlex>
  );

  return (
    <>
      <AppDeleteIcon onClick={showModal} className={styles.icon} />

      <AppModal
        visible={visible}
        maskClosable={false}
        onCancel={hideModal}
        content={content}
        destroyOnClose
        footer={footer}
        loading={isLoading}
        title="Удалить класс"
      />
    </>
  );
};
